
import { MotimaticUser } from "../../../models/motimaticUser.model.ts";
import { MotimaticUserSerializer } from "../../../models/serializers/MotimaticUserSerializer.ts";
import { httpRequest } from "../../http";

export class CommandMotimaticUsers {
    async run(engagementId: string) {  
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/motimatic-users/`
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
             return this.deserialize(response.users);
                    
                
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }

    deserialize(data: any) : MotimaticUser []{
        const serializer = new MotimaticUserSerializer();
        return serializer.deserializeList(data);
    }
    
}

